"use client";

import { Button } from "@/components/ui/button";
import { useUserLogout } from "@/hooks/user-hooks/useUserLogout";
import { useTypedTranslations } from "@/i18n/typed";
import { useRouter } from "next/navigation";
import { toast } from "sonner";

export default function Logout() {
  const t = useTypedTranslations("button");
  const { mutate: userLogoutMutate } = useUserLogout();
  const router = useRouter();
  const logoutHandle = () => {
    userLogoutMutate(undefined, {
      onSuccess: () => {
        toast.success(t('logoutSuccess'));
        router.refresh();
      },
    });
  };

  return (
    <Button
      className="text-gray-700 px-0 h-4 w-auto"
      size="xs"
      onClick={logoutHandle}
      appearance="link"
    >
      {t('logout')}
    </Button>
  );
}
